import { ClosingSection } from './sections/ClosingSection/ClosingSection'
import { CultureDisplaySection } from './sections/CultureDisplaySection/CultureDisplaySection'
import { EngagementSection } from './sections/EngagementSection/EngagementSection'
import { HeroSection } from './sections/HeroSection/HeroSection'
import { SpaceCommerceSection } from './sections/SpaceCommerceSection/SpaceCommerceSection'
import { TransformationSection } from './sections/TransformationSection/TransformationSection'
import { ScrollProgress } from './components/ScrollProgress/ScrollProgress'
import { useMediaDownloadDeterrence } from './hooks/useMediaDownloadDeterrence'
import styles from './App.module.css'

export default function App() {
  useMediaDownloadDeterrence()

  return (
    <div className={styles.app} data-motion-ready="true">
      <main>
        <HeroSection />
        <SpaceCommerceSection />
        <TransformationSection />
        <EngagementSection />
        <CultureDisplaySection />
        <ClosingSection />
      </main>
      <ScrollProgress />
    </div>
  )
}
